module.exports = __webpack_public_path__ + "static/7-f8cd09e2d9e0bbc29e8141dd1d510f3f.jpg";